var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('h1',[_vm._v("404 Page Not Found")]),_c('router-link',{staticStyle:{"text-decoration":"none !important"},attrs:{"to":"/"}},[_c('h4',{staticStyle:{"font-weight":"600","text-decoration":"underline","color":"#18191a"}},[_vm._v(" Go back home ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }